import { BlacklistReq } from 'models/backoffice/blacklist/types'
import * as yup from 'yup'

export const schema: yup.SchemaOf<BlacklistReq> = yup.object().shape({
  cpf: yup.string().required()
})
